module.exports = "//public.zight.com/packs/media/images/chrome-22a06d54f9355a04b791e13f84f44faf.svg";